import BaseFont from 'client/components/core/Sidebar/components/Settings/components/Font/BaseFont'
import TextAlignStyle from 'client/components/core/Sidebar/components/Settings/styles/TextAlignStyle'
import React from 'react'
import { GroupTitle } from 'src/editor/layout/sidebar/settings/group-title'
import { useHeadingTypography } from 'src/editor/shared/hooks/use-heading-typography'
import { useThemeColor } from 'src/editor/shared/hooks/use-theme-color'
import { useTypography } from 'src/editor/shared/hooks/use-typography'
import { ColorPickerControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-control'
import HeadingFont from '../../components/Font/HeadingFont'
import {
  useUpdateGlobalHeadingSettings,
  useUpdateGlobalSetting,
  useUpdateGlobalSettings,
} from '../../hooks/useUpdateGlobalSetting'
import FontSize from '../../styles/FontSize'
import LineHeight from '../../styles/LineHeight'

interface TypographyProps {
  skipFont?: boolean
  isRootSetting?: boolean
}

export const Typography = ({
  skipFont = false,
  isRootSetting = true,
}: TypographyProps) => {
  const updateGlobalSetting = useUpdateGlobalSetting()
  const updateGlobalFontStyle = useUpdateGlobalSettings()
  const updateGlobalHeadingFontStyle = useUpdateGlobalHeadingSettings()

  const {
    globalFontSize,
    globalMobileFontSize,
    globalFontFamily,
    globalFontStyle,
    globalFontWeight,
    globalTextAlign,
    globalMobileTextAlign,
    globalLineHeight,
    globalMobileLineHeight,
  } = useTypography()

  const {
    globalTextAlign: globalHeadingTextAlign,
    globalMobileTextAlign: globalMobileHeadingTextAlign,
    globalFontFamily: globalHeadingFontFamily,
    globalFontStyle: globalHeadinglFontStyle,
    globalFontWeight: globalHeadingFontWeight,
  } = useHeadingTypography()

  const {
    text: { paragraphTextColor, headingTextColor },
    links: { linkTextColor },
  } = useThemeColor()

  return (
    <div>
      <GroupTitle isFirst>page_settings.typography.title</GroupTitle>
      {!skipFont && (
        <BaseFont
          labelText=""
          inheritedFontTypeLabel={'settings_styles.font_family.default'}
          fontFamily={globalFontFamily}
          fontStyle={globalFontStyle}
          fontWeight={globalFontWeight}
          update={updateGlobalFontStyle}
          globalFontFamily={globalFontFamily}
          isRootSetting={isRootSetting}
        />
      )}
      <FontSize
        fontSize={globalFontSize}
        mobileFontSize={globalMobileFontSize}
        update={updateGlobalSetting('textFontSize', 'px')}
        mobileUpdate={updateGlobalSetting('mobileTextFontSize', 'px')}
      />
      <LineHeight
        lineHeight={globalLineHeight}
        mobileLineHeight={globalMobileLineHeight}
        fontSize={globalFontSize}
        mobileFontSize={globalMobileFontSize}
        update={updateGlobalSetting('textLineHeight', 'px')}
        mobileUpdate={updateGlobalSetting('mobileTextLineHeight', 'px')}
      />
      <ColorPickerControl
        update={updateGlobalSetting('linkColor')}
        color={linkTextColor}
        label="global_settings.link_color.label"
        singleColorMode
        isClearable
      />
      <ColorPickerControl
        update={updateGlobalSetting('textColor')}
        color={paragraphTextColor}
        label="global_settings.text_color.label"
        singleColorMode
        isClearable
      />
      <TextAlignStyle
        textAlign={globalTextAlign}
        mobileTextAlign={globalMobileTextAlign}
        update={updateGlobalSetting('textAlign')}
        mobileUpdate={updateGlobalSetting('mobileTextAlign')}
      />
      <GroupTitle>page_settings.typography.heading_title</GroupTitle>
      {!skipFont && (
        <HeadingFont
          fontFamily={globalHeadingFontFamily}
          fontStyle={globalHeadinglFontStyle}
          fontWeight={globalHeadingFontWeight}
          update={updateGlobalHeadingFontStyle}
        />
      )}
      <ColorPickerControl
        update={updateGlobalSetting('headingColor')}
        color={headingTextColor}
        label="global_settings.text_color.label"
        singleColorMode
        isClearable
      />
      <TextAlignStyle
        textAlign={globalHeadingTextAlign}
        mobileTextAlign={globalMobileHeadingTextAlign}
        update={updateGlobalSetting('headingAlign')}
        mobileUpdate={updateGlobalSetting('mobileHeadingAlign')}
      />
    </div>
  )
}
